"use strict";
exports.__esModule = true;
exports.LegendDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var alignPoints_1 = require("./alignPoints");
var LegendDialogWrapper = function (_a) {
    var children = _a.children;
    var isMobile = sdk_ui_kit_1.useMediaQuery("<sm");
    return children(isMobile);
};
var LegendDialogContent = function (props) {
    var title = props.title, onCloseDialog = props.onCloseDialog, children = props.children;
    var onClose = function (e) {
        e.preventDefault();
        onCloseDialog();
    };
    return (react_1["default"].createElement("div", { className: "legend-popup-dialog legend-popup-dialog-content" },
        react_1["default"].createElement("div", { className: "legend-header" },
            react_1["default"].createElement("div", { className: "legend-header-title" }, title),
            react_1["default"].createElement("div", { className: "s-legend-close legend-close gd-icon-cross gd-button-link gd-button-icon-only", onClick: onClose })),
        react_1["default"].createElement("div", { className: "legend-content" }, children)));
};
exports.LegendDialog = function (props) {
    var name = props.name, children = props.children, isOpen = props.isOpen, alignTo = props.alignTo, onCloseDialog = props.onCloseDialog;
    if (!isOpen) {
        return null;
    }
    return (react_1["default"].createElement(LegendDialogWrapper, null, function (isMobile) {
        return (react_1["default"].createElement(sdk_ui_kit_1.Overlay, { alignTo: alignTo, alignPoints: isMobile ? alignPoints_1.legendMobileDialogAlignPoints : alignPoints_1.legendDialogAlignPoints, closeOnOutsideClick: !isMobile, onClose: onCloseDialog, className: "kpi-alert-dialog-overlay" },
            react_1["default"].createElement(LegendDialogContent, { title: name, onCloseDialog: onCloseDialog }, children)));
    }));
};
//# sourceMappingURL=LegendDialog.js.map